const SpPlatformButtons = cleverapps.Layout.extend({
    ctor: function (buttonWidth, onClicked) {
        this.buttonWidth = Math.min(buttonWidth, cleverapps.styles.SpPlatformButtons.maxButtonWidth);
        this.onClicked = onClicked;

        this._super(this.createItems(), {
            direction: cleverapps.UI.VERTICAL,
            margin: cleverapps.styles.SpPlatformButtons.buttonsMargin
        });
    },

    createItems: function () {
        if (SpPlatformButtons.EASY_REGISTRATION_UNAVAILABLE.indexOf(cleverapps.config.name) === -1) {
            return this.createNewFormItems();
        }

        return this.createOldFormItems();
    },

    createNewFormItems: function () {
        const items = [];
        if (connector.social.mobagePlatformLogin) {
            items.push(this.createOneButton("ゲームを始める", this.createLink("同意事項等（必読)")));
        } else {
            items.push(this.createOneButton("モバゲーIDで始める", this.createLink("同意事項等（必読)")));
            items.push(this.createOneButton("新規かんたん会員で始める", this.createLink("会員規約等（必読)", true), true));
        }
        return items;
    },

    createOldFormItems: function () {
        const items = [];

        if (connector.social.mobagePlatformLogin) {
            items.push(this.createOneButton("インストール"));
        } else {
            items.push(this.createOneButton("ログイン"));
        }

        const msg = `ゲームをスタートするには${connector.social.mobagePlatformLogin ? "ゲームをインストール" : "ログイン"
        }してください。`;
        const text = cleverapps.UI.generateOnlyText(msg, cleverapps.styles.FONTS.BLACK_LINK_TEXT);
        text.setDimensions(Math.min(cleverapps.styles.SpPlatformButtons.maxTextWidth, cleverapps.resolution.getSceneSize().width * 0.7), 0);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        items.push(text);

        return items;
    },

    createOneButton: function (msg, link, registration) {
        const content = cleverapps.UI.generateOnlyText(msg, cleverapps.styles.FONTS.BUTTON_TEXT);

        const platformButton = new cleverapps.UI.Button({
            content,
            width: this.buttonWidth,
            onClicked: function () {
                this.onClicked({
                    registration
                });
            }.bind(this)
        });

        const items = [link, platformButton].filter((item) => {
            if (item) {
                item.alwaysOn = true;
            }
            return item;
        });
        return new cleverapps.Layout(items, {
            direction: cleverapps.UI.VERTICAL,
            margin: cleverapps.styles.SpPlatformButtons.linkMargin
        });
    },

    createLink: function (txt, registration) {
        const link1 = cleverapps.UI.generateOnlyText(txt, cleverapps.styles.FONTS.BLUE_LINK_TEXT);
        const link2 = cleverapps.UI.generateOnlyText(" に同意して", cleverapps.styles.FONTS.BLACK_LINK_TEXT);

        const msg = new cleverapps.Layout([link1, link2], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: cleverapps.styles.SpPlatformButtons.textMargin
        });

        cleverapps.UI.applyHover(msg);
        cleverapps.UI.onClick(msg, () => {
            if (registration) {
                mobage.ui.show("client_agreement_menu", { "isEasyRegistration": true });
            } else {
                mobage.ui.show("client_agreement_menu");
            }
        });

        return msg;
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    BLUE_LINK_TEXT: {
        size: 40,
        color: new cc.Color(62, 158, 254)
    },

    BLACK_LINK_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.BLACK
    }
});

// apps registered before 2020/12/1 cannot use new form easy registration of hybrid flow v2
SpPlatformButtons.EASY_REGISTRATION_UNAVAILABLE = [
    "riddles", "heroes", "tripeaks", "crocword", "runes"
];

cleverapps.styles.SpPlatformButtons = {
    buttonsMargin: 50,
    linkMargin: 10,
    textMargin: 5,
    maxButtonWidth: 600,
    maxTextWidth: 600
};